export class ChatConfig {
  public static EndPoint = {
    chat: {
      getUserMessage: '/solution/chat/getUserMessage',
      getChatUsers: '/solution/chat/getChatUsers',
      getChatUsersByCase: '/solution/chat/getChatUsersByCase/{id}',
      getChildByCase: '/integration/getChildByCase/{case_id}',
      addChatUsers: '/solution/chat/addChatUsers',
      getCaseList: '/integration/getCaseList',
      getUnreadMessages: '/solution/chat/getUnreadMessages',
      getUserSession: '/solution/chat/getUserSession/{id}',
      getOnlineUsers: '/solution/chat/getOnlineUsers'
    },
    document: {
      getSignedDocumentUrl: '/solution/chat/getSignedDocument',
      updateDocumentStatus: '/documentattachment/ApproveOrRejectAttachment/{document_id}',
      getAttachmentById: '/documentattachment/getAttachmentById/{document_id}',
      addAttachment: '/documentattachment/addAttachment'
    }
  };
}
